module.exports = __webpack_public_path__ + "img/live.96e988a2.png";